import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { flatMap, map, catchError } from 'rxjs/operators';
import { Epic, ofType } from 'redux-observable';
import { fetchActionTilesSuccess, fetchActionTilesError, FETCH_ACTION_TILES } from './actions';

export const fetchActionTilesEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_ACTION_TILES),
    flatMap(() =>
      ajax
        .getJSON('/content/workplace/en/participant/ri/content-pages/action-tiles.model.json')
        .pipe(map((res: any) => fetchActionTilesSuccess(res[`:items`].root[`:items`].contentfragmentlist.items)))
        .pipe(catchError(ex => of(fetchActionTilesError(ex)))),
    ),
  );
